import PropTypes from 'prop-types';
import React from 'react';
import history from '../../client/service/history';

export const LEFT_CLICK_BUTTON = 0;
export const MIDDLE_CLICK_BUTTON = 1;
export const RIGHT_CLICK_BUTTON = 2;
export const changeAppRoute = href => history.push(href);
const openInNewTab = href => window.open(href, '_blank');
const openInExistingWindow = href => window.location.assign(href);
const blockEvent = (event) => {
  event.stopPropagation();
  event.preventDefault();
};

export const handleLinkClick = ({ event = {}, href, onClick }) => {
  const isLeftMouseClick = event.button === LEFT_CLICK_BUTTON;
  const isMiddleMouseClick = event.button === MIDDLE_CLICK_BUTTON;
  const defaultNotPrevented = !event.defaultPrevented;
  const notAbsoluteUrl = !(/^[a-z][a-z0-9+.-]*:/.test(href));
  const hasModifiedEvent = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
  const shouldChangeAppRoute = (
    notAbsoluteUrl &&
    defaultNotPrevented &&
    isLeftMouseClick &&
    !hasModifiedEvent
  );
  const shouldOpenInTab = (hasModifiedEvent || isMiddleMouseClick);

  if (onClick) onClick();

  blockEvent(event);

  if (shouldChangeAppRoute) {
    changeAppRoute(href);
  } else if (shouldOpenInTab) {
    openInNewTab(href);
  } else if (isLeftMouseClick) {
    openInExistingWindow(href);
  }
};

export const Link = ({ children, className, href, title, onClick, ...rest }) => (
  <a
    href={href}
    className={className}
    title={title}
    onClick={event => handleLinkClick({ event, href, onClick })}
    {...rest}
  >
    {children}
  </a>
);

Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default Link;
